export default __webpack_public_path__ + "static/media/calendar_1.7bcb01b6.svg";